<template>
    <router-view />
</template>

<script>
export default {
    inject: ['reload'],
    data() {
        return {}
    },
    created() {
        this.$nextTick(() => {
            if (this.$route.path === '/setting') {
                this.$router.replace({
                    path: '/setting/system'
                })
            }
        })
    },
    mounted() {
        this.$nextTick(() => {})
    },
    methods: {}
}
</script>

<style scoped lang="less"></style>
